import CrowdfundingPage from './crowdfunding_page'
import { connect } from 'react-redux'
import { fromVeniceSelector } from 'redux/selectors/venice'
import {
  getAllowEntryBannerSelector,
  isMoneyPoolSelector,
} from 'redux/selectors/campaign'

const mapStateToProps = (state, { campaignId, showHeader, showFooter }) => {
  const fromVenice = fromVeniceSelector()(state)
  if (fromVenice) {
    showHeader = false
    showFooter = false
  }
  const isMoneyPool = isMoneyPoolSelector(state, { campaignId })

  return {
    isMoneyPool,
    showHeader,
    showFooter,
    isLoggedIn: state.login_info && state.login_info.logged_in,
    allowEntryBanner: getAllowEntryBannerSelector(state, { campaignId }),
    paypalDomain: state.geo.paypalDomain,
    banner: state.personalizationStudio.banner,
  }
}
export default connect(mapStateToProps)(CrowdfundingPage)
